/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取东艺剧院导航条, 返回二级结构导航条
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.TheaterNavigationDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/dongyi-navs`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
